import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { useTranslation } from "react-i18next";

const ElderProfileView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("profile");
  const elderID = localStorage.getItem("elderID");
  const kinkeeperID = localStorage.getItem("kinkeeperID");
  const token = localStorage.getItem("token");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!elderID || (!kinkeeperID && !token)) {
      alert(t("create.sessionExpired"));
      navigate("/elders/new");
      return;
    }

    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/patient/profile/${elderID}`, {
          params: { kinkeeperID },
          headers: { Authorization: `Bearer ${token}` }
        });

        setProfile(res.data.patient);
      } catch (err) {
        alert(err.response?.data?.error || t("create.loadFailed"));
        navigate("/elders/new");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [elderID, kinkeeperID, token, navigate, t]);

  if (loading) {
    return <div className="loading-state">{t("view.loading")}</div>;
  }

  if (!profile) {
    return <div className="empty-state">{t("view.notFound")}</div>;
  }

  const gender =
    profile.gender === "M" ? t("fields.male") : profile.gender === "F" ? t("fields.female") : "";

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content">
          <div className="intro-badge">{t("view.badge")}</div>
          <h1 className="page-title">
            {profile.firstName} {profile.lastName}
          </h1>
          <p className="page-subtitle">
            {t("view.subtitle")}
          </p>

          <div className="details-grid section-block">
            <Field fieldLabel={t("fields.firstName")} value={profile.firstName} />
            <Field fieldLabel={t("fields.lastName")} value={profile.lastName} />
            <Field fieldLabel={t("fields.email")} value={profile.email} />
            <Field fieldLabel={t("fields.relationship")} value={profile.relationship} />
            <Field fieldLabel={t("fields.language")} value={profile.spokenLanguage} />
            <Field fieldLabel={t("fields.gender")} value={gender} />
            <Field fieldLabel={t("fields.country")} value={profile.country} />
            <Field fieldLabel={t("fields.state")} value={profile.stateProvince} />
            <Field fieldLabel={t("fields.city")} value={profile.city} />
            <Field fieldLabel={t("fields.whatsapp")} value={profile.whatsapp} />
          </div>

          <div className="button-row">
            <button className="ghost-button" onClick={() => navigate(-1)}>
              {t("view.btnBack")}
            </button>
            <button className="warm-button" onClick={() => navigate("/elders/new")}>
              {t("view.btnEdit")}
            </button>
            <button className="button" onClick={() => navigate("/elders")}>
              {t("view.btnViewAll")}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

const Field = ({ fieldLabel, value }) => {
  if (!value) return null;

  return (
    <div className="detail-card">
      <div className="field-label">{fieldLabel}</div>
      <div className="detail-value">{value}</div>
    </div>
  );
};

export default ElderProfileView;
